import Vue from 'vue'
import Vuex from 'vuex'
import { formatText } from '@/utils/i18n'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    currentLang: 'zh',
    currentRole: 'connect-agent',
    currentPlatform: '抖音',
    user: {
      name: '张经理',
      avatar: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80'
    },
    platforms: [
      { value: '抖音', label: '抖音' },
      { value: '快手', label: '快手' },
      { value: '视频号', label: '视频号' },
      { value: 'TT', label: 'TT' },
      { value: 'Youtube', label: 'Youtube' },
      { value: 'Ins', label: 'Ins' }
    ],
    roles: [
      { value: 'connect-agent', label: 'role_connect_agent' },
      { value: 'streamer-agent', label: 'role_streamer_agent' },
      { value: 'operation-agent', label: 'role_operation_agent' },
      { value: 'publish-agent', label: 'role_publish_agent' }
    ],
    // 从接口获取的可用角色列表
    availableRoles: [],
    // 角色代码到内部角色值的映射
    roleCodeMapping: {
      'Recuriting': 'connect-agent',      // 建联经纪人
      'Creator': 'streamer-agent',        // 主播
      'Operation': 'operation-agent',     // 运营经纪人
      'VideoProducer': 'publish-agent',    // 视频剪辑师
      'HR': 'recruitment-agent'           // 招聘智能体
    },
    // 角色代码到显示名称的映射
    roleNameMapping: {
      'Recuriting': '建联经纪人',
      'Creator': '主播',
      'Operation': '运营经纪人',
      'VideoProducer': '视频剪辑师',
      'HR': '招聘智能体',
      'Admin': '管理员'
    },
    // 角色代码到菜单key的映射
    roleMenuMapping: {
      'Recuriting': 'connect',
      'Creator': 'streamer',
      'Operation': 'operation',
      'VideoProducer': 'video',
      'HR': 'recruitment'
    },
    languages: [
      { value: 'zh', label: '中文' },
      { value: 'en', label: 'English' },
      { value: 'ja', label: '日本語' }
    ],
    dashboardData: {
      activeStreamers: 128,
      incomeToday: 89432,
      liveSessions: 45,
      newFans: 1234
    }
  },
  mutations: {
    SET_LANGUAGE(state, lang) {
      state.currentLang = lang
    },
    SET_ROLE(state, role) {
      state.currentRole = role
    },
    SET_PLATFORM(state, platform) {
      state.currentPlatform = platform
    },
    UPDATE_DASHBOARD_DATA(state, data) {
      state.dashboardData = { ...state.dashboardData, ...data }
    },
    setCurrentLang(state, lang) {
      state.currentLang = lang
    },
    setCurrentRole(state, role) {
      state.currentRole = role
    },
    setCurrentPlatform(state, platform) {
      state.currentPlatform = platform
    },
    SET_AVAILABLE_ROLES(state, roles) {
      state.availableRoles = roles
    }
  },
  actions: {
    changeLanguage({ commit }, lang) {
      commit('SET_LANGUAGE', lang)
    },
    changeRole({ commit }, role) {
      commit('SET_ROLE', role)
    },
    changePlatform({ commit }, platform) {
      commit('SET_PLATFORM', platform)
    },
    updateDashboardData({ commit }, data) {
      commit('UPDATE_DASHBOARD_DATA', data)
    },
    setAvailableRoles({ commit }, roles) {
      commit('SET_AVAILABLE_ROLES', roles)
    }
  },
  getters: {
    t: (state) => (key, params = {}) => {
      return formatText(key, params, state.currentLang)
    },
    currentRoleLabel: (state, getters) => {
      const role = state.roles.find(r => r.value === state.currentRole)
      return role ? getters.t(role.label) : ''
    },
    currentPlatformLabel: (state) => {
      return state.currentPlatform
    },
    currentLanguageLabel: (state) => {
      const lang = state.languages.find(l => l.value === state.currentLang)
      return lang ? lang.label : ''
    }
  }
}) 